export const mimeTypes = {
  csv: 'text/csv',
  xlsx: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  pdf: 'application/pdf',
  jpg: 'image/jpeg',
  png: 'image/png',
  bmp: 'image/bmp',
};



// WEBPACK FOOTER //
// ./src/submodules/sellions_forms/projects/forms/src/lib/components/controls/multipart-files/mime-types.const.ts